import React, { useState, useEffect, useContext, useRef, Fragment } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserProgressContext from "../../userProgressContext";
import BackgroundSoundToggle from "../BackgroundSound/backGroundSoundToggle";
import SoundManager from "../../services/SoundManager";
import ToggleNavbar from "./toggleNavbar";
import GGABtn from "./ggaBtn";
import PlayerSettingsModal from "./PlayerSettingsModal";
import PlayerMenuDropdown from "./PlayerMenuDropdown";
import GridStatusPanel from "../UI/GridStatusPanel";

const Navbar = () => {
  const { audioMuted, totalScore, emailId, name } = useContext(UserProgressContext);
  const [isToggleOpen, setIsToggleOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeView, setActiveView] = useState(null); // "name" | "email"
  const menuButtonRef = useRef(null);
  const [enlarged, setEnlarged] = useState(false);
  const [ggaEnabled, setGgaEnabled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const closeNavbar = () => setIsToggleOpen(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        closeNavbar();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (totalScore > 0) {
      setEnlarged(true);
      if (!ggaEnabled) setGgaEnabled(true);

      SoundManager.playSfx('coins-collection');
    }
  }, [totalScore]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const timer = setTimeout(() => setEnlarged(false), 300);
    return () => clearTimeout(timer);
  }, [enlarged]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleGGANav = () => {
    SoundManager.playSfx('game-retro-click');
    navigate("/gridGuardArsenal", {
      state: { previousLocationPathname: location.pathname },
    });
  };
  const levelMatch = location.pathname.match(/\/level\/(\d+)/);
  const showGridStatus = levelMatch && parseInt(levelMatch[1]) >= 2 && parseInt(levelMatch[1]) <= 5;

  const toggleNavbar = () => {
    setIsToggleOpen(!isToggleOpen);
  };
  return (
    <Fragment>
    <div
      className={`sticky top-0 left-0 bg-cyber-bg border-b border-cyber-dim text-cyber-text transform min-[1024px]:translate-x-0 transition-transform duration-300 ease-in-out z-50`}
    >
      <div className="p-2 min-[1024px]:p-4 flex justify-between items-center">
        <div className="flex gap-4">
          <div
            className="flex flex-col gap-1 min-[1024px]:hidden cursor-pointer justify-center"
            onClick={toggleNavbar}
          >
            <span className="w-6 h-1 rounded-lg bg-white"></span>
            <span className="w-6 h-1 rounded-lg bg-white"></span>
            <span className="w-6 h-1 rounded-lg bg-white"></span>
          </div>
          {isToggleOpen && (
            <ToggleNavbar
              onClose={toggleNavbar}
              ggaEnabled={ggaEnabled}
              handleGGANav={handleGGANav}
            />
          )}
          <Link
            className="text-xl md:text-2xl font-bold text-cyber-accent hover:text-cyber-text tracking-widest uppercase transition-colors duration-200"
            to="/"
          >
            Cyber Adventure
          </Link>
        </div>
        <div className="text-center flex gap-2 text-lg md:text-xl text-cyber-faint">
          <span className="text-xs md:text-sm tracking-widest uppercase self-center">Total Points:</span>
          <span
            className={`font-bold tracking-wider transition-all ease-out duration-300 ${
              enlarged ? "scale-125 text-safe" : "scale-100 text-cyber-accent"
            }`}
          >
            {totalScore}
          </span>
        </div>
        <div className="flex gap-3 items-center">
          {showGridStatus && <GridStatusPanel />}
          {/* <button
            disabled={
              location && location.pathname.includes("gridGuardArsenal")
            }
            className={`text-xs md:text-base ${
              ggaEnabled ? "visible" : "invisible"
            } ${
              location && location.pathname.includes("gridGuardArsenal")
                ? "cursor-not-allowed text-orange-400 border-orange-400"
                : "text-white border-white"
            } border rounded-full hidden md:flex p-0.5 md:p-2 gap-0 md:gap-2 items-center hover:scale-105 hover:text-orange-400 hover:border-orange-400 transition-all ease-out delay-100`}
            onClick={() => handleGGANav()}
          >
            <FontAwesomeIcon icon={faShield} />
            GridGuard Arsenal
          </button> */}
          {emailId && location.pathname !== "/" && (
            <div className="relative">
              <button
                ref={menuButtonRef}
                onClick={() => setIsDropdownOpen((prev) => !prev)}
                title={name ? `Signed in as ${name}` : "Player settings"}
                className={`flex items-center gap-1.5 text-xs md:text-sm border rounded-full px-2 py-1 transition-colors duration-200 uppercase tracking-widest ${
                  isDropdownOpen
                    ? "border-cyber-accent text-cyber-accent"
                    : "border-cyber-dim text-cyber-sub hover:border-cyber-accent hover:text-cyber-accent"
                }`}
              >
                <span className="text-base leading-none">☰</span>
                <span className="hidden md:inline">Menu</span>
              </button>
              {isDropdownOpen && (
                <PlayerMenuDropdown
                  onSelect={(view) => {
                    setIsDropdownOpen(false);
                    setActiveView(view);
                  }}
                  onClose={() => setIsDropdownOpen(false)}
                />
              )}
            </div>
          )}
          <BackgroundSoundToggle />
        </div>
      </div>
    </div>
    {activeView && (
      <PlayerSettingsModal view={activeView} onClose={() => setActiveView(null)} />
    )}
    </Fragment>
  );
};

export default Navbar;
